export default (node:any, options:any) => {
  node.attribs = {...node.attribs, role:"application"}
  return node
}